import {
    GET_RESOURCE_IMAGES,
    UPLOAD_RESOURCE_IMAGES,
    CLEAR_RESOURCE_IMAGES,
    DELETE_RESOURCE_IMAGES,
} from '../constants/action-types';

// INITIALIZE STATE
const initialState = {
    resourceImages: {}
};

// REDUCER
export const ResourceImageManagerReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RESOURCE_IMAGES: {
            const incomingResourceImages = action.payload
            const resourceImages = {}

            incomingResourceImages.forEach(image => {
                resourceImages[image] = {
                    name: image
                }
            })

            return {
                ...state,
                resourceImages
            }
    }
        case UPLOAD_RESOURCE_IMAGES: {
    return {
        ...state,
    }
}

        case CLEAR_RESOURCE_IMAGES: {
    return {
        ...state,
        resourceImages: {}
    }
}

        case DELETE_RESOURCE_IMAGES: {
    return {
        ...state
    }
}
        default:
return state;
    }
};